import { Component, Prop, Vue } from 'vue-property-decorator'
import { genId } from '@/helpers/gen-id'

import CardInitial from '@/views/InitialManagement/YearMonthList/CardInitial/index.vue'

@Component({
	components: {
		CardInitial,
	},
})
export default class YearMonthList extends Vue {
	@Prop() readonly initials

	today = new Date().toISOString().split('T')[0]

	get years() {
		const uniqueYears = new Set()
		this.initials.forEach((initial) => {
			// date format = 'YYYY-MM-DD'
			uniqueYears.add(initial.date.split('-')[0])
		})

		return ([...uniqueYears] as string[]).sort(
			(a, b) => parseInt(a) - parseInt(b),
		)
	}

	get structuredInitials() {
		const monthNames = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		]
		const structuredInitials = [] as any
		this.years.forEach((year) => {
			const initialsInSameYear = this.initials.filter(
				(initial) => initial.date.split('-')[0] === year,
			)

			const initialsInMonths = [] as any
			monthNames.forEach((month, index) => {
				const monthNumber = index + 1
				const initialsInSameYearMonth = initialsInSameYear.filter(
					(initial) =>
						monthNumber === parseInt(initial.date.split('-')[1]),
				)

				if (initialsInSameYearMonth.length) {
					initialsInMonths.push({
						month,
						htmlId: genId(),
						initials: initialsInSameYearMonth,
					})
				}
			})

			structuredInitials.push({
				year,
				htmlId: genId(),
				months: initialsInMonths,
			})
		})

		return structuredInitials
	}

	getDays(tasks) {
		const uniqueDays = new Set()
		tasks.forEach((task) => {
			// date format = 'YYYY-MM-DD'
			uniqueDays.add(task.date.split('-')[2])
		})

		return uniqueDays
	}

	getTasksInDay(tasks, day) {
		return tasks.filter((task) => task.date.split('-')[2] === day)
	}

	addZeroBefore(numberString) {
		if (numberString.length === 1) {
			return '0' + numberString
		}

		return numberString
	}
}
